export const TENANT_ID = 'trillium-connect';
export const APP_ID = 'trillium-connect-web';

export const MASONRY = {
  // Updated from demoHomePage$root — Trillium homescreen node spec merged in TRIL-392 (EverlongProject/services#44318).
  ROOT_NODE_ID_HOME_PAGE: 'homescreen$root',
  ROOT_NODE_ID_SUPPORT_PAGE: 'support$root',
};

export const QUERY_PARAM_MODAL_VALUE = {
  DELETE_ACCOUNT: 'delete-account',
  DELETE_ACCOUNT_DISCLAIMER: 'delete-account-disclaimer',
};

export enum QUERY_PARAM_KEYS {
  MODAL = 'modal',
}
